import { render } from "./Answer.vue?vue&type=template&id=78ee62a0&scoped=true&ts=true"
import script from "./Answer.vue?vue&type=script&lang=ts"
export * from "./Answer.vue?vue&type=script&lang=ts"

import "./Answer.vue?vue&type=style&index=0&id=78ee62a0&scoped=true&lang=scss"

import exportComponent from "/data/.jenkins/workspace/k8s-shouba-exhibitionhall-h5-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78ee62a0"]])

export default __exports__